import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import HeroSection from '../../components/HeroSection/HeroSection';
import ContentSection from '../../components/ContentSection/ContentSection';
import GalleryModal from '../../components/GalleryModal/GalleryModal';
import analyticsService from '../../services/analyticsService';

const HomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  useEffect(() => {
    analyticsService.recordPageView('home_page').catch(() => {});
  }, []);

  // Redirect logged-in users to their respective dashboards
  useEffect(() => {
    if (isAuthenticated && user) {
      switch (user.user_type) {
        case 'Admin':
        case 'SubAdmin':
          navigate('/admin', { replace: true });
          break;
        case 'Airliner':
          navigate('/airliner/profile', { replace: true });
          break;
        case 'JetSetter':
          // JetSetter can access home page, no redirect needed
          break;
        default:
          break;
      }
    }
  }, [isAuthenticated, user, navigate]);

  // Gallery images - matching PHP structure
  const galleryImages = [
    {
      id: 1,
      src: '/public/hero-image.jpeg',
      thumbnail: '/public/hero-image.jpeg',
      alt: 'Private jet exterior view',
      type: 'image'
    },
    {
      id: 2,
      src: '/howitworks.jpeg',
      thumbnail: '/howitworks.jpeg',
      alt: 'Luxury flight experience',
      type: 'image'
    },
    {
      id: 3,
      src: '/whatwedo.jpeg',
      thumbnail: '/whatwedo.jpeg',
      alt: 'Private jet interior',
      type: 'image'
    },
    {
      id: 4,
      src: '/whoweare.jpeg',
      thumbnail: '/whoweare.jpeg',
      alt: 'Aviation technology',
      type: 'image'
    },
    {
      id: 5,
      src: '/public/hero-image.jpeg',
      thumbnail: '/public/hero-image.jpeg',
      alt: 'Private jet video preview',
      type: 'video',
      videoSrc: '/assets/images/video.mp4'
    }
  ];

  const openGallery = (index = 0) => {
    setSelectedImageIndex(index);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
  };

  return (
    <>
      <HeroSection />
      <ContentSection />

      {/* Gallery Modal */}
      <GalleryModal
        isOpen={isGalleryOpen}
        onClose={closeGallery}
        images={galleryImages}
        initialIndex={selectedImageIndex}
      />
    </>
  );
};

export default HomePage;